<template>
    <section class="payment-section section has-text-centered has-text-right-desktop">
        <div class="columns is-vcentered is-variable is-5">
            <div class="column content is-marginless">
                <div class="level is-marginless">
                    <div class="level-left"></div>

                    <div class="level-right is-hidden-touch">
                        <figure class="image is-3by1 is-marginless">
                            <!--suppress HtmlUnknownTarget -->
                            <img
                                :alt="$saas.name"
                                :src="require(`@/assets/${ $saas.logo }`)">
                        </figure>
                    </div>

                    <div class="level-right is-hidden-desktop">
                        <figure class="image is-marginless">
                            <!--suppress HtmlUnknownTarget -->
                            <img
                                :alt="$saas.name"
                                :src="require(`@/assets/${ $saas.logo }`)">
                        </figure>
                    </div>
                </div>
                <h2 class="title is-2 has-text-info is-marginless">
                    {{ $t(`common.transactionStatus.successPayment.header`) }}
                </h2>
    
                <p>
                    {{ $t(`common.transactionStatus.successPayment.body`) }}
                </p>
    
                <b-button
                    :to="{ name: 'main' }"
                    rounded
                    tag="router-link"
                    type="is-success">
                    {{ $t(`common.transactionStatus.successPayment.button`) }}
                </b-button>
            </div>
            <div class="column is-narrow">
                <figure class="image">
                    <!--suppress HtmlUnknownTarget -->
                    <img
                        alt="success image"
                        src="icons/transactions/succeed.svg">
                </figure>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: "SuccessPayment"
  };
</script>

<style lang="scss" scoped>
    .title {
        line-height: inherit;
    }

    .image {
        //noinspection SassScssUnresolvedMixin
        @include touch {
            max-width: 60%;
            margin: auto !important;
        }

        &.is-1by1 {
            width: 175px;
        }

        &.is-3by1 {
            width: 124px;
        }
    }
</style>

